export const LOCALSTORE_KEY_AUTH = "auth";
export const LOCALSTORE_KEY_LOCALE = "language";
export const LOCALSTORE_KEY_CART = "cart";
